/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
 import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
 import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
 import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat';
 import AutoLink from '@ckeditor/ckeditor5-link/src/autolink';
 import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote';
 import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
 import CloudServices from '@ckeditor/ckeditor5-cloud-services/src/cloudservices';
 import DocumentList from '@ckeditor/ckeditor5-list/src/documentlist';
 import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
 import Heading from '@ckeditor/ckeditor5-heading/src/heading';
 import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight';
 import ImportWord from '@ckeditor/ckeditor5-import-word/src/importword';
 import Indent from '@ckeditor/ckeditor5-indent/src/indent';
 import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock';
 import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
 import Link from '@ckeditor/ckeditor5-link/src/link';
 import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
 import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
 import PresenceList from '@ckeditor/ckeditor5-real-time-collaboration/src/presencelist';
 import RealTimeCollaborativeComments from '@ckeditor/ckeditor5-real-time-collaboration/src/realtimecollaborativecomments';
 import RealTimeCollaborativeEditing from '@ckeditor/ckeditor5-real-time-collaboration/src/realtimecollaborativeediting';
 import RealTimeCollaborativeTrackChanges from '@ckeditor/ckeditor5-real-time-collaboration/src/realtimecollaborativetrackchanges';
 import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat';
 import SelectAll from '@ckeditor/ckeditor5-select-all/src/selectall';
 import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters';
 import SpecialCharactersArrows from '@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows';
 import SpecialCharactersCurrency from '@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency';
 import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials';
 import SpecialCharactersLatin from '@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin';
 import SpecialCharactersMathematical from '@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical';
 import SpecialCharactersText from '@ckeditor/ckeditor5-special-characters/src/specialcharacterstext';
 import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough';
 import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript';
 import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript';
 import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation';
 import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline';
 import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount';
 //@ts-ignore
 // import WProofreader from '@webspellchecker/wproofreader-ckeditor5/src/wproofreader';
 import Comments from '@ckeditor/ckeditor5-comments/src/comments';
 import TrackChanges from '@ckeditor/ckeditor5-track-changes/src/trackchanges';
 import EditorWatchdog from '@ckeditor/ckeditor5-watchdog/src/editorwatchdog';
 
 class Editor extends ClassicEditor {}
 
 // Plugins to include in the build.
 Editor.builtinPlugins = [
     Alignment,
     Autoformat,
     AutoLink,
     BlockQuote,
     Bold,
     CloudServices,
     DocumentList,
     Essentials,
     Heading,
     Highlight,
     ImportWord,
     Indent,
     IndentBlock,
     Italic,
     Link,
     Paragraph,
     PasteFromOffice,
     PresenceList,
     RealTimeCollaborativeComments,
     RealTimeCollaborativeEditing,
     RealTimeCollaborativeTrackChanges,
     RemoveFormat,
     SelectAll,
     SpecialCharacters,
     SpecialCharactersArrows,
     SpecialCharactersCurrency,
     SpecialCharactersEssentials,
     SpecialCharactersLatin,
     SpecialCharactersMathematical,
     SpecialCharactersText,
     Strikethrough,
     Subscript,
     Superscript,
     TextTransformation,
     Underline,
     WordCount,
     // WProofreader,
     Comments,
     TrackChanges,
 ];
 
 // Editor configuration.
 Editor.defaultConfig = {
     toolbar: {
         items: [
             'undo',
             'redo',
             'heading',
             '|',
             'bold',
             'italic',
             'underline',
             'strikethrough',
             'link',
             'blockQuote',
             'subscript',
             'superscript',
             '|',
             'numberedList',
             'bulletedList',
             'outdent',
             'indent',
             'alignment',
             '|',
             'comment',
             'trackChanges',
             'selectAll',
             'specialCharacters',
             // 'wproofreader',
             // 'exportPdf'
         ]
     },
     language: 'en',
     comments: {
         editorConfig: {
             extraPlugins: [
                 Bold,
                 Italic,
                 Autoformat
             ]
         }
     }
 };
 
 export default Editor;